import schemas, { EventSchemas } from './schemas';

export type Validators = {
  getSchema: <T extends keyof EventSchemas>(type: T) => EventSchemas[T];
};

export const getValidators = (): Validators => ({
  getSchema: <T extends keyof EventSchemas>(type: T): EventSchemas[T] => {
    const schema = schemas[type];
    if (!schema) throw new Error(`Validation schema for type ${String(type)} was not found`);
    return schema;
  },
});
